<template>
  <div class="h-100">
    <!-- TODO: apply any markup that is common to all private views and not shared with the public views Private View -->
    <appHeader></appHeader>
    <b-container class="wrapper d-flex flex-column" style="min-height:calc(100vh - 160px);">
      <router-view></router-view>
    </b-container>
    <appFooter></appFooter>
  </div>
</template>

<script>
import appHeader from './shared/components/header'
import appFooter from './shared/components/footer'

export default {
  components: { appHeader, appFooter }
}
</script>
